require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// /Users/m802941/.nvm/versions/node/v10.0.0/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/es6.typed.int8-array.js
// module id = 301
// module chunks = 9